<template>
    <span>
        <svg-icon width="24" height="24" viewBox="0 0 24 24" iconName="age-limit-icon">
            <path d="M13.4663 10.8864C15.103 8.72938 13.5623 5.6001 10.8386 5.6001C9.02047 5.6001 7.54131 7.07926 7.54131 8.89741C7.54131 9.64396 7.79105 10.3331 8.21092 10.8864C5.27041 13.3457 7.02714 18.1356 10.8386 18.1356C14.6586 18.1356 16.4012 13.3411 13.4663 10.8864ZM9.80468 8.89741C9.80468 8.32732 10.2685 7.86354 10.8385 7.86354C11.4086 7.86354 11.8724 8.32732 11.8724 8.89741C11.8724 9.46757 11.4086 9.93135 10.8385 9.93135C10.2685 9.93135 9.80468 9.46749 9.80468 8.89741ZM10.8385 15.8722C9.82467 15.8722 8.9998 15.0473 8.9998 14.0335C8.9998 13.0196 9.82467 12.1948 10.8385 12.1948C11.8524 12.1948 12.6773 13.0197 12.6773 14.0335C12.6774 15.0473 11.8525 15.8722 10.8385 15.8722Z" :fill="fill"/>
            <path d="M3.32726 5.67432H1.13172C0.506709 5.67432 0 6.18103 0 6.80604C0 7.43105 0.506709 7.93776 1.13172 7.93776H2.19554V17.0781C2.19554 17.7031 2.70225 18.2098 3.32726 18.2098C3.95227 18.2098 4.45898 17.7031 4.45898 17.0781V6.80604C4.45898 6.18103 3.95227 5.67432 3.32726 5.67432Z" :fill="fill"/>
            <path d="M22.8682 8.23908H21.3592V6.7317C21.3592 6.10669 20.8525 5.59998 20.2275 5.59998C19.6025 5.59998 19.0958 6.10669 19.0958 6.7317V8.23908H17.5868C16.9618 8.23908 16.4551 8.74579 16.4551 9.3708C16.4551 9.99582 16.9618 10.5025 17.5868 10.5025H19.0958V12.0147C19.0958 12.6398 19.6025 13.1465 20.2275 13.1465C20.8525 13.1465 21.3592 12.6398 21.3592 12.0147V10.5025H22.8682C23.4932 10.5025 23.9999 9.99582 23.9999 9.3708C23.9999 8.74579 23.4932 8.23908 22.8682 8.23908Z" :fill="fill"/>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-age-limit',
    computed: {
        fill() {
            return this.active ? '#fff' : 'url(#red-light)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        active: {
            type: Boolean,
            default: false
        }
    },
}
</script>